module.exports = __webpack_public_path__ + "images/109_2048.jpg";